// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"2eae87f6","140":"79ba9ee7","280":"c3ff4c7c","308":"47bf25b0","384":"90cee1e8","458":"b57215c6","601":"2cd60c99","769":"4488b22a","837":"f5a7e7f7","889":"2eb93f42"}[chunkId] + ".chunk.js";
};